import { ReactNode, useEffect, useRef } from 'react';
import { useAuthStore } from '@store/useAuthStore';
import { adminsControllerGetMyProfileV1, adminsControllerRefreshTokenV1 } from '@api/generated/admin-auth/admin-auth';

type AuthInitializerProps = {
    children: ReactNode;
}

// 앱 초기화 시 인증 상태를 검증 및 토큰을 갱신하는 컴포넌트
const AuthInitializer = ({ children }: AuthInitializerProps) => {
    const { isAuthenticated, accessToken, setAccessToken, setAdmin, logout, setIsLoading } = useAuthStore();
    const isInitialized = useRef(false);

    useEffect(() => {
        // 이미 초기화된 경우 스킵
        if (isInitialized.current) return;
	
	    const initializeAuth = async () => {
		    // 조건에 해당하지 않으면 로딩을 건드릴 필요도 없이 즉시 종료
		    if (!isAuthenticated || accessToken) {
			    setIsLoading(false); // 혹시 true였다면 해제
			    isInitialized.current = true;
			    return;
		    }
		
		    // 토큰 갱신이 필요한 경우
		    setIsLoading(true);
		    try {
			    // accessToken 갱신
			    const tokenResponse = await adminsControllerRefreshTokenV1();
			    setAccessToken(tokenResponse.accessToken);
			    
			    // 관리자 정보 조회
			    const adminResponse = await adminsControllerGetMyProfileV1();
			    setAdmin(adminResponse);
		    } catch {
			    // 갱신 실패 또는 만료 시 로그아웃
			    logout();
		    } finally {
			    setIsLoading(false);
			    isInitialized.current = true;
		    }
	    };

        initializeAuth();
    }, [isAuthenticated, accessToken, setAccessToken, setAdmin, logout, setIsLoading]);

    return children;
};

export default AuthInitializer;
